document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(function (mutationsList, observer) {
        const closeButton = document.querySelector('.bss-modal-button-close'); // aria-busy="true"
        const removeAttr = document.querySelector('button[name="checkout"]');
        if (closeButton) {
            closeButton.addEventListener('click', function () {
              removeAttr.removeAttribute('aria-busy');
                //alert('Button clicked!');
            });
            observer.disconnect();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
